export default "__VITE_PUBLIC_ASSET__7b7ed149__"